export default import.meta.ROLLDOWN_FILE_URL_YX6$NSe6Is5DaOJZGqVRkQ